export const GET_SUBSCRIBE_PAYMENTS = "admin/GET_SUBSCRIBE_PAYMENTS";
export const GET_SUBSCRIBE_PAYMENTS_SUCCESS =
  "admin/GET_SUBSCRIBE_PAYMENTS_SUCCESS";
export const GET_SUBSCRIBE_PAYMENTS_FAILURE =
  "admin/GET_USUBSCRIBE_PAYMENTS_FAILURE";
